import React, { Component } from 'react';
import { browserHistory } from 'react-router'

import { checkCookie } from '../../cookies/';
import { COOKIE_KEY } from '../../config/session';

import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';

import './style.css';

class App extends Component {
  componentWillMount() {
    if (!checkCookie(COOKIE_KEY)) {
      browserHistory.push('/pages/login')
    }
  }
  render() {
    return (
      <div className="app">
        <Header />
        <div className="app-body">
          <Sidebar {...this.props} />
          <main className="main">
            <div className="container-fluid pt-2">
              {this.props.children}
            </div>
          </main>
          <Aside />
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./containers/App/index.js